import styled from "@emotion/styled";
import TextArea from "../../../../Common/TextArea/TextArea";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import ArrowUpwardTwoToneIcon from "@mui/icons-material/ArrowUpwardTwoTone";
import TextInput from "../../../../Common/Textfield/Textfield";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

export const UploadedFilesContainer = styled.div`
  // display: flex;
  // flex-direction: column;
  // gap: 12px;
  // border: 1px solid var(--border__color);
  // padding: 10px;
  // border-radius: 5px;
  // max-height: 120px;
  overflow-y: auto;
`;

export const UploadedFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  // background-color: #f8f9fa;
  border: 2px dotted #6860ee;
  border-radius: 8px;
`;

export const FileNameContainer = styled.span`
  font-size: 14px;
  color: var(--header__color);
  flex-grow: 1;
  margin-right: 8px;
  word-break: break-word;
`;

export const DeleteIconDiv = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    fill: #d32f2f;
    transition: transform 0.2s;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;
export const TrackingMainContainer = styled("div")({
  height: "auto",
  // padding: "20px 20px",
  // borderBottom: "1px solid #ddd",
  // boxShadow: "0px 4px 10px 0px #0000002A",
  // borderRadius: "10px",
  // border:"1px solid var(--border__color)",
  "@media screen and (max-width:1220px)": {
    padding: "10px",
  },
});
export const TrackingMainInnerContainer = styled("div")({
  margin: "0px 0px 20px 0px",
  "@media screen and (max-width:1220px)": {
    margin: "10px",
  },
});
export const TrackingUpperOuterContainer = styled("div")({
  // border: "1px solid #ACACAC",
  // padding: "20px",
  borderRadius: "10px",
});
export const TrackingUpperContainer = styled("div")({
  display: "flex",
  marginTop: "10px",
  flexDirection: "column",
});
export const TrackingLowerContainer = styled("div")({
  position: "relative",
  padding: "0px 15px 0px 40px",
  "&.tracking-lowercontainer::after": {
    position: "absolute",
    content: '""',
    width: "10px",
    height: "10px",
    background: "#fff",
    border: "3px solid #6860ee",
    left: "0",
    borderRadius: "100%",
    top: "0px",
  },
  "&.tracking-lowercontainer::before": {
    position: "absolute",
    content: '""',
    width: "10px",
    height: "100%",
    borderRight: " 2px dotted #6860ee",
    left: "-3px",
    top: "18px",
  },
  "&.tracking-lowercontainer:last-child::before": {
    border: " none",
  },
  "@media screen and (max-width:1220px)": {
    padding: "0px 10px",
  },
});
export const TrackingLowerDisplayContainer = styled("div")({
  position: "relative",
  maxHeight: "500px",
  overflowY: "auto",
  borderRadius: "16px",
  // width: "85%",
  padding: "10px",
  "@media screen and (max-width:1220px)": {
    border: "1px solid var(--border__color)",
    boxShadow: "0px 4px 10px 0px #0000001A",
  },
  "@media screen and (max-width:991px)": {
    width: "97%",
  },
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "5px",
    backgroundColor: "#e6f1f5",
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "5px",
    backgroundColor: "#1b52a729",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: " #1b52a742",
  },
  "&::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#1b52a740",
  },
});
export const TrackingLowerInnerContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "10px",
  marginTop: "10px",
  justifyContent: "space-between",
  "@media screen and (max-width:1220px)": {
    margin: "10px",
  },
});
export const TrackingPageHeader = styled("h2")({
  fontSize: "17px",
  fontWeight: "600",
  margin: "0",
  // marginTop: "30px",
  marginBottom: "30px",
  color: "var(--header__color)",
});
export const historyInfoContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid var(--border__color);
  padding: 10px;
  border-radius: 10px;
  background-color: var(--history_text_color);
  margin-bottom: 20px;
  width: fit-content;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;
export const HistoryInfoText = styled("h4")`
  margin-bottom: 0;
  margin-top: 0;
  color: #6665ea;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
export const HistoryButtonContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  margin-top: 20px;
`;
export const HeaderSubTitle = styled("span")`
  color: var(--page_Header_Color);
  font-size: 12px;
  margin-left: 5px;
`;
export const AddTrackButtonContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
`;
export const TrackingHeader = styled("h3")({
  fontSize: "16px",
  fontWeight: "500",
  margin: "0",
  marginTop: "30px",
  marginBottom: "10px",
  color: "var(--header__color)",
});
export const TrackingHistoryHeader = styled("h3")({
  fontSize: "16px",
  fontWeight: "500",
  color: "var(--header__color)",
  margin: "0",
  marginTop: "30px",
  marginBottom: "10px",
});
export const StyledTextArea = styled(TextArea)({
  width: "100%",
  height: "100px",
  resize: "none",
  padding: "10px",
  border: "1px solid var(--border__color)",
  borderRadius: "7px",
  boxSizing: "border-box",
  "&:focus-within": {
    outline: "none",
  },
  "@media screen and (max-width:1220px)": {
    padding: "6px 0px 0px 13px",
  },
  "&::-webkit-scrollbar": {
    width: "10px",
    height: "10px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "5px",
    backgroundColor: "#e6f1f5",
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "5px",
    backgroundColor: "#1b52a729",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: " #1b52a742",
  },
  "&::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#1b52a740",
  },
});
export const TrackingLeftContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "25px",
  justifyContent: "space-between",
  "@media screen and (max-width:1240px)": {
    flexWrap: "nowrap",
  },
});
export const AddTrackingLeftContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "25px",
  width: "100%",
  justifyContent: "space-between",
  "@media screen and (max-width:1200px)": {
    flexDirection: "column",
  },
});

export const StyledRemainderContainer = styled("div")({
  display: "grid",
  gap: "10px",
  alignItems: "start",
});
export const TrackingRightContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
});
export const TrackingTextAreaDiv = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  "@media screen and (max-width:1200px)": {
    width: "100%",
  },
});
export const StyledJobContainer = styled("div")({
  margin: "10px 0",
  display: "flex",
  flexDirection: "row",
  alignItems: "baseline",
});
export const StyledScheduler = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  "@media screen and (max-width:1200px)": {
    width: "100%",
  },
});
export const AutoCompleteContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "50%",
  // marginTop:"-2vw",
  // "@media screen and (max-width:1200px)": {
  //   width: "100%",
  // },
});
export const CallStageDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "50%",
  // marginTop:"-2vw",
  "@media screen and (max-width:1240px)": {
    marginBottom: "50px",
  },
});
export const JobOptions = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: "10px",
  "@media screen and (max-width:1220px)": {
    justifyContent: "flex-start",
  },
});
export const NewJob = styled("a")({
  cursor: "pointer",
  margin: 0,
  color: "#6860ee",
  fontSize: "14px",
  fontWeight: "400",
  marginLeft: "5px",
});
export const ViewJob = styled("a")({
  margin: 0,
  cursor: "pointer",
  color: "#6860ee",
  fontSize: "14px",
  fontWeight: "400",
  borderRight: "1px solid #6860ee",
  padding: "0px 5px 0px 0px",
});
export const StyledButtonDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  "@media screen and (max-width:1220px)": {
    justifyContent: "center",
    marginTop: "50px",
  },
});
export const ContentContainer = styled("div")({
  borderRadius: "10px",
  border: "1px solid var(--border__color)",
  boxShadow: "0px 4px 10px 0px #0000001A",
  padding: "10px 20px",
  margin: "10px 0px 0px 0px",
  whiteSpace: "pre-line",
  "@media screen and (max-width:1220px)": {
    margin: "10px 0 0 10px",
  },
});
export const ContentDescription = styled("div")({
  display: "flex",
  flexDirection: "row",
  padding: "10px 10px",
});
export const ContentInnerDescription = styled("div")({
  padding: "0px",
  "&.content-innerdescriptions": {
    padding: "10px 20px",
  },
});
export const DeleteIcondiv = styled("div")({
  padding: "0px 20px",
  cursor: "pointer",
});
export const ContentStatusContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  justifyContent: "flex-end",
  width: "100%",
  // margin: "10px 0px 0px 0px",
  "@media screen and (max-width:1220px)": {
    width: "20% !important",
  },
});
export const ContentIcon = styled(SquareRoundedIcon)({
  width: 30,
  height: 30,
  color: "#ccc",
});
export const TrackingContentDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  "@media screen and (max-width:1220px)": {
    marginRight: "10px",
    gap: "10px",
  },
});
export const ContentDate = styled("p")({
  margin: "0",
  fontSize: "14px",
  fontWeight: "400",
  color: "var(--header__color)",
});
export const InfoName = styled("p")({
  color: "#6860ee",
  fontWeight: "400",
  position: "relative",
  paddingRight: "10px",
  margin: "0",
  "&::after": {
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    width: "1px",
    background: "#6860EE",
  },
});
export const InfoNameClient = styled("p")({
  color: "#6860ee",
  fontWeight: "400",
  paddingLeft: "10px",
  margin: "0",
});
export const RecruiterTag = styled.div`
  display: inline-block;
  color: #636ae6;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  margin-top: 8px;
`;
export const NoTrackingHistory = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
});

export const NoTrackingHistoryTextContainer = styled("div")({
  border: "1px solid #f7dcb6",
  borderRadius: "5px",
  background: "var(--information_Note_Background)",
  padding: "5px 10px",
  width: "fit-content",
  display: "flex",
  color: "#fb9b27",
  fontweight: "500",
  fontSize: "14px",
});
export const InfoNamespan = styled("span")({
  // fontFamily: "Inter",
  fontSize: "14px",
  fontWeight: "500",
  textAlign: "left",
  margin: "0",
});
export const CandidateInnerDetailsDiv = styled("div")({});
export const Content = styled("p")({
  margin: "0",
  wordBreak: "break-word",
  padding: "10px 10px",
});
export const ContentStatus = styled("p")({
  margin: "0",
  padding: "8px",
  borderRadius: "10px",
  fontSize: "14px",
  fontWeight: 500,
  transition: "all 0.3s ease-in-out",
  "@media screen and (max-width:1220px)": {
    fontSize: "12px",
  },
});

export const ContentJob = styled("p")({
  margin: "0",
  padding: "3px",
  color: "#7c94ad",
});
export const ContentClient = styled("p")({
  margin: "0",
  padding: "3px",
  color: "#7c94ad",
});
export const FileDropCircle = styled("div")({
  width: 33,
  height: 33,
  border: "1px dotted #acbac9",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f4f3f2",
});
export const FileDropIcon = styled(ArrowUpwardTwoToneIcon)({
  color: "#acbac9",
});
export const DocumentDescription = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "60px",
  marginTop: "40px",
  justifyContent: "center",
  width: "100%",
  "@media screen and (max-width:1200px)": {
    flexDirection: "column",
    gap: "0px",
  },
});
export const DocxIcon = styled("img")({
  margin: 0,
  width: "25px",
  height: "25px",
  marginRight: "20px",
  paddingTop: "5px",
});
export const ContentParagraph = styled("p")({
  fontWeight: "400",
  fontSize: "14px",
  color: "#000000",
});
export const DeleteIcon = styled(DeleteOutlineOutlinedIcon)({
  marginLeft: "20px",
  cursor: "pointer",
});
export const CandidateDetailsOuter = styled("div")({
  boxShadow: "0px 4px 10px 0px #0000001A",
  alignItems: "center",
  border: "1px solid #ACACAC",
  borderRadius: "8px",
  padding: "10px 15px",
  margin: "0px 20px",
});
export const CloseIconDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});
export const CandidateDetails = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "30px",
  padding: "0px 10px 10px 10px",
  borderBottom: "1px solid #ACACAC",
});
export const CandidateDetailsCTC = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  padding: "10px 0px 0px 0px",
});
export const CandidateInnerDetailsCTC = styled("div")({
  display: "flex",
  gap: "10px",
  position: "relative",
  alignItems: "center",
  paddingRight: "10px",
  "&::after": {
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    width: "1px",
    background: "#ACACAC",
  },
});
export const CandidateInnerDetailsInfo = styled("span")({
  fontSize: "14px",
  fontWeight: "400",
});
export const CandidateInnerDetailsValue = styled("span")({
  fontWeight: "600",
  fontSize: "14px",
  color: "#000000",
});
export const CandidateInnerDetails = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "Center",
  gap: "10px",
});
export const CandidateNotice = styled("p")({
  margin: 0,
  paddingTop: "10px",
});

export const CandidateCTC = styled("p")({
  margin: 0,
  paddingTop: "10px",
});

export const CandidateECTC = styled("p")({
  margin: 0,
  paddingTop: "10px",
});

export const CandidateOptions = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-end",
  height: "100%",
  rowGap: "50px",
});

export const CandidateContact = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const CandidateMail = styled("div")({
  paddingTop: "10px",
  display: "flex",
  columnGap: "10px",
});

export const CandidateMobile = styled("div")({
  paddingTop: "10px",
  display: "flex",
  columnGap: "10px",
});

export const CandidateLocation = styled("div")({
  paddingTop: "10px",
  display: "flex",
  columnGap: "10px",
});

export const ShowMoreDiv = styled("div")({
  cursor: "pointer",
  display: "flex",
  justifyContent: "flex-end",
});
export const ShowMore = styled("p")({
  fontSize: "14px",
  fontWeight: "400",
  color: "#6860ee",
});
export const IconText = styled("p")({
  margin: "0",
  fontSize: "12px",
  textAlign: "center",
});

export const IconContainer = styled("div")({
  margin: "0",
  display: "flex",
  flexDirection: "column",
});
export const CandidateDetailsDiv = styled("div")({
  color: "#6860ee",
});
export const ClientDetailsDiv = styled("div")({});

// document page jsx
export const DocumentLeftContainer = styled("div")({
  margin: 0,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  "@media screen and (max-width:1220px)": {
    gap: "10px",
    flexDirection: "column",
  },
});
export const FileDropMainContainer = styled("div")({
  width: "70%",
  "@media screen and (max-width:1220px)": {
    width: "100%",
  },
});

export const FileDropContainer = styled("div")(({ isDragging }) => ({
  padding: "30px 50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  border: isDragging ? "2px dashed #0055a5" : "2px dashed #ccc",
  borderRadius: "16px",
  cursor: "pointer",
  // backgroundColor: isDragging ? "aliceblue" : "none",
}));
export const FileDropMessage = styled("p")({
  fontSize: "12px",
  fontWeight: "400",
  color: "var(--header__color)",
});
export const FileName = styled("div")({
  marginTop: "25px",
});
export const NoteContainer = styled("div")({});
export const NoteHeading = styled("p")({
  fontWeight: "500",
  fontSize: "14px",
  color: "var(--header__color)",
});
export const NoteListContainer = styled("ul")({
  margin: 0,
  // padding: "0 15px",
  // width: "100%",
});
export const NoteList = styled("li")({
  margin: 0,
  fontSize: "12px",
  fontWeight: "400",
  color: "var(--header__color)",
  lineHeight: "20px",
  "&::marker": {
    color: "#6860EE",
  },
});
export const DocumentRightContainer = styled("div")({
  margin: 0,
  display: "flex",
  flexDirection: "column",
});
export const DescriptionHeading = styled("p")({
  fontWeight: "400",
  fontSize: "14px",
  color: "#000000",
});
export const DescriptionSpan = styled("span")({
  fontSize: "12px",
  fontWeight: "400",
  color: "#000000",
});
export const DocumentDescriptionInnerDiv = styled("div")({
  width: "70%",
  "@media screen and (max-width:1220px)": {
    width: "100%",
  },
});
export const DescriptionTextBox = styled(TextInput)({
  width: "100%",
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxSizing: "border-box",
  margin: "0 0 20px 0",
});
export const StyledDocumentaButtonDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  "@media screen and (max-width:1200px)": {
    width: "100%",
    justifyContent: "center",
  },
});
export const DocumentMainInnerContainer = styled("div")({
  width: "100%",
  padding: "10px 0px",
  // "@media screen and (max-width:1200px)": {

  // },
});
export const ContentDocumentContainer = styled("div")({
  border: "0.5px solid var(--border__color)",
  borderRadius: "12px",
  transition: "border-color 0.15s, background 0.15s",
  "&:hover": {
    borderColor: "#534AB7",
    background: "#EEEDFE22",
  },
});

export const ContentDocumentDescription = styled("div")({
  display: "flex",
  flexDirection: "row",
  padding: "14px 16px",
  borderRadius: "12px",
  alignItems: "center",
  gap: "14px",
});
export const PdfIcon = styled("img")({
  margin: 0,
  width: "25px",
  height: "25px",
  marginRight: "20px",
  paddingTop: "5px",
});
export const ContentItems = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
});

export const ContentHeading = styled("h5")({
  margin: 0,
  marginBottom: "10px",
  color: "#6860EE",
  marginTop: "10px",
});

export const DocumentHeading = styled("h3")({
  fontsize: "20px",
  fontWeight: "500",
  colors: "#000000",
  margin: "0",
  // marginTop: "50px",
  marginBottom: "20px",
  marginTop: "20px",
});

export const DocumentHistoryHeading = styled("h3")({
  fontsize: "20px",
  fontWeight: "500",
  colors: "#000000",
  margin: "0",
  marginTop: "30px",
  marginBottom: "20px",
});

export const DocumentLowerContainer = styled("div")({
  maxHeight: "500px",
  overflowY: "auto",
  borderRadius: "16px",
  padding: "12px",
  // border: "1px solid #DDDDDD",
  // boxShadow: "0px 4px 10px 0px #0000001A",
  "@media screen and (max-width:1220px)": {
    border: "1px solid #DDDDDD",
    boxShadow: "0px 4px 10px 0px #0000001A",
  },
  "&::-webkit-scrollbar": {
    width: "10px",
    height: "10px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "5px",
    backgroundColor: "#e6f1f5",
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "5px",
    backgroundColor: "#1b52a729",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: " #1b52a742",
  },
  "&::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#1b52a740",
  },
});

export const DocumentContainer = styled("div")({});
export const ContentMainContainer = styled("div")({
  marginTop: "0px",
  borderRadius: "10px",
  padding: "10px",
});

export const SecondaryContentMainContainer = styled("div")({
  borderRadius: "10px",
  margin: 0,
  // padding: "10px",
  width: "100%",
  //  "@media screen and (max-width:1220px)": {
  //  width:"90vw",
  // },
});

export const StyledCheckboxDiv = styled("div")({
  marginBottom: "10px",
});

export const DetailsDiv = styled("div")({
  display: "flex",
  flexDirection: "justify-content",
});

export const StyledFileTailContents = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "5px",
});

// Track History Css..
export const OuterTrackDetailsContainer = styled("div")({
  border: "1px solid #ccc",
  padding: "15px",
  borderRadius: "10px",
  marginBottom: "15px",
});

export const CallStageDetailsContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #ccc",
  paddingBottom: "15px",
  marginBottom: "10px",
});

export const TrackJobName = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
});

export const InnerTrackContents = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const TrackContentImage = styled("img")({
  // width: "20px",
  // height: "20px",
});

export const InnerContent = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const TrackContentContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: "10px",
  marginBottom: "5px",
  marginTop: "10px",
});

export const RemarksContainer = styled("div")`
  border: 2px solid var(--trackhistory_remark_bg);
  padding: 5px 10px;
  background-color: var(--trackhistory_remark_bg);
  border-radius: 10px;
`;

export const SpanHeader = styled("span")`
  font-size: 14px;
  font-weight: 400;
`;

export const SpanValue = styled("span")`
  font-size: 14px;
  font-weight: 600;
`;
export const TrackRemarkContent = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "5px",
  marginBottom: "5px",
});

export const RemarkHeader = styled("span")`
  font-size: 16px;
  font-weight: 600;
  color: #5b5bff;
`;
export const RemarkValue=styled("span")`
  white-space: pre-wrap;
  word-wrap: break-word;
  display: block;
  font-family: inherit;
  line-height: 1.5;
`
export const SelectedJobTitle = styled("span")`
  font-size: 18px;
  font-weight: 600;
`;
export const RemarkHeaderAndValue = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

